import { useState, useEffect, useRef, startTransition } from 'react'
import { useNavigate } from 'react-router-dom'
import mockData from './mock.json'
import { getUrlQuery, loTrack } from '@utils'
import { useSelector, useDispatch } from 'react-redux'
import { ICommonSearchInputProps } from '.'

export const useSearchInput = (props: ICommonSearchInputProps) => {
  // 传递数据
  const { isFixed, isSearch } = props
  // store数据
  const searchInputState = useSelector((state: any) => state.searchInput)
  const dispatch = useDispatch()
  const { keywords, autoCompleteList } = searchInputState || {}

  const navigate = useNavigate()
  const searchRef = useRef<HTMLDivElement>(null)
  const [data, setData]: any = useState({
    fixedStyle: {},
    isInit: true // 标识初始加载不显示联想结果出来，等聚焦才显示
  })

  // dispatch
  const setKeywords = (str: string) => {
    dispatch({
      type: 'searchInput/updateKeywords',
      payload: str
    })
  }
  const setAutoCompleteList = (arr: any[]) => {
    dispatch({
      type: 'searchInput/updateAutoCompleteList',
      payload: arr
    })
  }

  const clearKeywords = () => {
    setKeywords('')
  }

  let lazyTimer: any = null
  const handleInput = (e: any) => {
    const val = e.target.value
    setKeywords(val)
    // 据输入查询提示字段-防抖处理
    if (val) {
      // 防抖操作（防止多次快速输入导致的请求过多）
      clearTimeout(lazyTimer)
      lazyTimer = setTimeout(() => {
        // fetchData()
      }, 200)
    } else {
      setAutoCompleteList([])
      setData({
        ...data,
        isInit: false
      })
    }
  }

  const [isFocus, setIsFocus] = useState(false)
  const handleFocus = () => {
    // 聚焦显示auto
    setData({
      ...data,
      isInit: false,
      fixedStyle: computedStyle()
    })
    setIsPopupVisible(true)
    setIsFocus(true)
  }
  const handleBlur = () => {
    setIsFocus(false)
  }

  // 将返回的搜索关键字替换样式
  const keywordStyle = (str: string) => {
    if (!keywords.trim().length) return false
    return str.replace(
      new RegExp(keywords, 'ig'),
      `<mark class="bold">${keywords}</mark>`
    )
  }

  const toSearch = () => {
    if (!keywords.trim().length) return false
    //const newKeyword = keywords?.replace(/\s/g, '').toLocaleLowerCase()
    loTrack('Search')

    // 跳转搜索页
    navigate(`/search?keywords=${encodeURIComponent(keywords)}`)
    startTransition(() => {
      // 跳转后重置
      setAutoCompleteList([])
      setData({
        ...data,
        isInit: true
      })
      // onCallback && onCallback()
    })
  }

  // 动态计算style样式
  const computedStyle = () => {
    if (!isFixed) return
    // 获取到input搜索框的位置
    const rect: any = searchRef.current.getBoundingClientRect()
    if (rect) {
      return {
        position: 'fixed',
        width: rect.width,
        top: rect.top + rect.height + 10,
        left: rect.left
      }
    }
  }

  // 联想数据下拉框点击其他位置隐藏
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const popupRef = useRef<HTMLDivElement>(null)
  const handleClickOutside = (event: any) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      searchRef.current &&
      !searchRef.current.contains(event.target)
    ) {
      setIsPopupVisible(false)
    }
  }

  // 监听关键词的变化-联想功能数据填充
  useEffect(() => {
    if (keywords.trim().length) {
      setAutoCompleteList([...mockData.data.autocompleteList])
    } else {
      setAutoCompleteList([])
    }
  }, [keywords])

  // 初始化加载-填充输入框
  useEffect(() => {
    if (isSearch) {
      const querys = getUrlQuery()
      if (querys.length) {
        const arr = querys
          .filter((_: any) => _.indexOf('keywords') > -1)[0]
          ?.split('=')
        if (arr && arr.length) {
          setKeywords(arr[1])
        }
      }
    }
    const rootEle: any = isSearch ? document.getElementById('root') : document
    rootEle?.addEventListener('click', handleClickOutside)
    // 卸载
    return () => {
      rootEle?.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      // 在这里处理按下回车键的逻辑
      toSearch()
    }
  }

  return {
    isFocus,
    searchRef,
    keywords,
    handleInput,
    handleFocus,
    handleBlur,
    handleKeyDown,
    clearKeywords,
    toSearch
  }
}
